import { apiGet } from "../fetch";

export interface AssignmentLlmQueueStat {
	assignment_id: number;
	llm_queue_count: number;
}

export async function getAssignmentLlmQueueStats(
	assignmentIds: number[]
): Promise<AssignmentLlmQueueStat[]> {
	if (assignmentIds.length === 0) {
		return [];
	}

	return (await apiGet(
		`/api/v2/assignment_llm_queue_stats/?assignment_ids=${assignmentIds.join(",")}`
	)) as AssignmentLlmQueueStat[];
}
